// Copyright 2022 The Parca Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useMemo } from 'react';
import { USER_PREFERENCES, useUserPreference } from '@parca/hooks';
import { selectDarkMode, setFeatures, useAppDispatch, useAppSelector, } from '@parca/store';
import { extractFeature } from './utils';
var colorNodes = function (nodes, strings, mappings, locations, functions, features) {
    if (nodes === undefined) {
        return [];
    }
    return nodes.map(function (node) {
        var coloredNode = __assign({}, node);
        if (node.children != null) {
            coloredNode.children = colorNodes(node.children, strings, mappings, locations, functions, features);
        }
        var feature = extractFeature(node, mappings, locations, strings, functions);
        coloredNode.feature = feature.name;
        features[feature.name] = feature.type;
        return coloredNode;
    });
};
var useColoredGraph = function (graph) {
    var dispatch = useAppDispatch();
    var colorProfile = useUserPreference(USER_PREFERENCES.FLAMEGRAPH_COLOR_PROFILE.key)[0];
    var isDarkMode = useAppSelector(selectDarkMode);
    var _a = useMemo(function () {
        var _a;
        if (graph.root == null) {
            return [graph, {}];
        }
        var features = {};
        var coloredGraph = __assign(__assign({}, graph), { root: __assign(__assign({}, graph.root), { children: colorNodes((_a = graph.root.children) !== null && _a !== void 0 ? _a : [], graph.stringTable, graph.mapping, graph.locations, graph.function, features) }) });
        return [coloredGraph, features];
    }, [graph]), coloredGraph = _a[0], features = _a[1];
    useEffect(function () {
        dispatch(setFeatures({ features: features, colorProfileName: colorProfile, isDarkMode: isDarkMode }));
    }, [features, colorProfile, dispatch, isDarkMode]);
    return coloredGraph;
};
export default useColoredGraph;
